var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"switch",class:{ isDisabled: _vm.isDisabled && !_vm.isInCampaignManager }},[_c('input',{attrs:{"type":"checkbox","disabled":_vm.isDisabled},domProps:{"checked":_vm.checked},on:{"change":_vm.onChangeEventHandler}}),_c('span',{staticClass:"slider round",class:{ isDisabled: _vm.isDisabled && !_vm.isInCampaignManager }})])
}
var staticRenderFns = []

export { render, staticRenderFns }